import React from "react"
import ReactDOM from "react-dom/client"
import { AdminAuthProvider } from "@components/search/AdminSignIn"
import App from "./App"

console.log("[main.tsx] Script loaded")

// Set platform attribute for CSS variables
console.log("[main.tsx] Setting data-platform attribute to 'standalone'")
document.documentElement.setAttribute("data-platform", "standalone")

console.log("[main.tsx] React:", React)
console.log("[main.tsx] ReactDOM:", ReactDOM)
console.log("[main.tsx] App:", App)

// Mount the app
const rootElement = document.getElementById("root")
console.log("[main.tsx] Root element:", rootElement)

if (rootElement) {
	console.log("[main.tsx] Creating React root...")
	const root = ReactDOM.createRoot(rootElement)
	console.log("[main.tsx] Rendering App...")
	root.render(
		<React.StrictMode>
			<AdminAuthProvider>
				<App />
			</AdminAuthProvider>
		</React.StrictMode>,
	)
	console.log("[main.tsx] App rendered")
} else {
	console.error("[main.tsx] Root element not found!")
}
